__turbopack_context__.v({
  "active": "BottomBar-module__-C_gIa__active",
  "bookCall": "BottomBar-module__-C_gIa__bookCall",
  "content": "BottomBar-module__-C_gIa__content",
  "rightPadded": "BottomBar-module__-C_gIa__rightPadded",
  "root": "BottomBar-module__-C_gIa__root",
  "subContent": "BottomBar-module__-C_gIa__subContent",
  "typeformContainer": "BottomBar-module__-C_gIa__typeformContainer",
});
